
import { Profile } from "@/hooks/profile/types";

export const useProfileValidation = () => {
  // Función de validación estricta mejorada
  const isFieldEmpty = (field: string | null | undefined): boolean => {
    if (field === null || field === undefined) return true;
    if (typeof field !== 'string') return true;
    return field.trim() === "";
  };

  // Función para validar si el perfil está incompleto
  const isProfileIncomplete = (profileData: Profile | null): boolean => {
    if (!profileData) return true;
    
    return (
      isFieldEmpty(profileData.first_name) || 
      isFieldEmpty(profileData.last_name) || 
      isFieldEmpty(profileData.birthdate)
    );
  };

  return {
    isFieldEmpty,
    isProfileIncomplete
  };
};
